import RequestPageTwo from "./RequestPageTwo";

const SoloRetreatOnline = () => {
    return (
        <RequestPageTwo title="Solo Retreat Online"
            fetchUrl="/get-solo-retreat-registrations"
            editEndpoint="update-solo-retreat-registrations"
            deleteEndpoint="solo-retreats"
            statusEndpoint="solo-retreat-registrations" />
    );
}

export default SoloRetreatOnline;
